// ABOUTME: Every string of screen 4A, the Make It Right card and its Hold state, in one place.
// ABOUTME: The Hold pill and the Create label are definition actions, not strings here; the catalog lists these.

export const CARD_HEADLINE = 'What was reached can be made right — that’s how the line mends.';
export const CARD_SUB = 'Talk together: check in, fix, finish, return, tell the truth, or give time.';
// A Reset has no list, so its one button carries this label in place of the Hold pill's.
export const RESET_BUTTON = 'Resetting early helps make it right';

export const HOLD_EYEBROW = 'SET THINGS RIGHT · ADDED TO YOUR KULEANA LIST';
export const HOLD_HEADLINE = 'At the core of every family and relationship is trust. By making it right, we repair that trust and relationship.';
export const HOLD_SUB = 'Feel free to exit and focus on making it right — we will hold your spot until you’re finished. Then we can come back and finish the rest of this crossing.';
// The dimmed plate's own headline and sub under Hold.
export const HOLD_PLATE_HEADLINE = 'The mend is on your Kuleana list — we’ll hold your spot.';
export const HOLD_PLATE_SUB = 'Come back when it’s done; the rest of the crossing waits here.';

export const ADDS_TO = 'ADDS TO';
export const RESPONSIBILITIES = 'Responsibilities';
export const NEW_TAG = 'New';
